import React, { useEffect } from "react";
import popupsyle from "../../../style/PopUp.module.css";
import { MdClose } from "react-icons/md";

const ImagePreview = ({ onClose, selectedImage }) => {
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.keyCode === 27) {
        onClose();
      }
    };
    window.addEventListener("keydown", handleEsc);
    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [onClose]);

  return (
    <div className={popupsyle.popupBackground} onClick={onClose}>
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            width: "80%",
            height: "80%",
            position: "relative",
            borderRadius: "12px",
            overflow: "hidden",
            padding: "20px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backdropFilter: "blur(4px)",
            background: "rgba(0, 0, 0, 0.48)",
          }}
        >
          <button
            onClick={onClose}
            style={{
              position: "absolute",
              top: "15px",
              right: "15px",
              background: "transparent",
              border: "none",
              borderRadius: "50%",
              width: "40px",
              height: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              color: "white",
              fontSize: "24px",
              zIndex: 10,
              transition: "all 0.2s ease",
            }}
          >
            <MdClose />
          </button>
          <div
            style={{
              overflow: "hidden",
              borderRadius: "8px",
              maxWidth: "100%",
              maxHeight: "calc(90vh - 40px)",
            }}
          >
            <img
              src={selectedImage}
              alt="Preview"
              style={{
                maxWidth: "100%",
                maxHeight: "80vh",
                objectFit: "contain",
                display: "block",
                borderRadius: "4px",
                boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImagePreview;
